// Stub for usePlaceholderImage
export function usePlaceholderImage(props) {
    return {
        imageProps: props
    };
}
